module.exports = __webpack_public_path__ + "84cd7f3d34ca8ccbd7d80f6177548b26.png";